export default __webpack_public_path__ + "assets/monitor.1767a453.svg";